import { useEffect, useState } from "react";
import { IDashOption, transplantedUtility } from "../transplanted/models";
import { IDashRegistrationForTransplantedList, IDashRegistrationsForTransplantedResponse } from '@nkr/store/microsites/actions-transplanted';
import { Typeahead } from "react-bootstrap-typeahead";
import { Alert, FormControl, FormGroup, Label } from "react-bootstrap";
import { Highlighter } from "react-bootstrap-typeahead";
import { connect, Dispatch } from "react-redux";
import { IApplicationState, MicrositeActionCreators } from "@nkr/store/index";

interface IProps {
    micrositeId: number,
    recipientId: number,
    value: number,
    enabled: boolean,
    onChange: (v:number) => void, 
}

interface IStateProps { }

interface IDispatchProps {
    getDashRegistrationsForTransplanted: (micrositeId: number, recipientId: number) => Promise<IDashRegistrationsForTransplantedResponse>,
}

type TProps = IProps & IStateProps & IDispatchProps;

const DashRegistrationTypeahead = ({micrositeId, recipientId, value, enabled, onChange, getDashRegistrationsForTransplanted}:TProps) => {
    
    const [dashRegistrations, setDashRegistrations] = useState<IDashRegistrationForTransplantedList[]>([]);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);
    
    useEffect(()=>{
        setIsLoading(true);
        getDashRegistrationsForTransplanted(micrositeId, recipientId).then(r => {
            setDashRegistrations(r.data.results);
        }).catch((ex) => {
            setError(ex);
        }).finally(() => {
            setIsLoading(false);
        });
    },[micrositeId]);

    const optionList: IDashOption[] = dashRegistrations?.map(r => {
        return transplantedUtility.createDashOption(r);
    });
    
    const selected = optionList.filter(o => o.id == value)
    
    const handleChange = (v:IDashOption) => {
        onChange(v[0]?.id)
    }

    if (error) {
        return <Alert bsStyle='danger'>An error occurred while retrieving donors. If this error persists please contact support.</Alert>;
    }

    if (isLoading) {
        return <Alert bsStyle='info'>Loading Donors ...</Alert>
    }

    return (<>
        <Typeahead
            id='dash'
            clearButton={true}
            labelKey={option => `${option.firstName} ${option.lastName} ${option.birthDate} ${option.email}`}
            options={optionList}
            selected={selected}
            disabled={!enabled}
            filterBy={['firstName', 'lastName', 'email', 'birthDate']}
            renderInput={(inputProps) => (
                <FormControl {...inputProps} />
            )}
            renderMenuItemChildren={(option, props, index) => {
                return (
                    <div style={{ borderBottom: '1px solid #ddd', paddingBottom: 5 }}>
                        <Highlighter search={props.text}>{`${option.firstName} ${option.lastName}`}</Highlighter>
                        {option.birthDate != '' && (
                            <div><small>DOB: <Highlighter search={props.text}>{option.birthDate}</Highlighter></small></div>
                        )}
                        <div><small>Email: <Highlighter search={props.text}>{option.email}</Highlighter></small></div>
                        {option.isFromMicrosite && (
                            <div><Label bsStyle='success'>Registered through Microsite</Label></div>
                        )}
                    </div>
                );
            }}
            onChange={handleChange}
        />
    </>);
}

const mapStateToProps = (state: IApplicationState): IStateProps => {
    return {
        app: state.app
    };
}

const mapDispatchToProps = (dispatch: Dispatch<any>): IDispatchProps => {
    return {
        getDashRegistrationsForTransplanted: (micrositeId, recipientId) => {
            return dispatch(MicrositeActionCreators.getDashRegistrationsForTransplanted(micrositeId, recipientId));
        }
    };
}

export default connect<IStateProps, IDispatchProps, IProps>(
    mapStateToProps,
    mapDispatchToProps)(DashRegistrationTypeahead);